/**
 * Created by decipaliz on 12.03.2024
 */

GoalsView.prototype.createStartAnimation = function () {
    const scene = cleverapps.Scenes.GetRunningScene();
    const styles = cleverapps.styles.GoalsView.startAnimation;

    const baseScale = styles.messagesScale[cleverapps.resolution.mode] / this.scale;
    let availableWidth = styles.width;

    this.views.forEach((view) => {
        view.upForStartAnimation();
        availableWidth -= view.width / styles.goals.scale[cleverapps.resolution.mode];
    });

    const margins = this.views.length + 1;
    const margin = availableWidth / margins * styles.goals.scale[cleverapps.resolution.mode];

    const startAnimation = this.startAnimation = new cleverapps.Layout(this.views, {
        direction: cleverapps.UI.HORIZONTAL,
        margin
    });

    startAnimation.setAlignment((-scene.width - this.startAnimation.width) / 2, scene.height / 2 + styles.goals.y * baseScale);
    startAnimation.setAnchorPoint(0.5, 0.5);
    startAnimation.setLocalZOrder(7);

    scene.addChild(startAnimation);

    let targetPosition = cc.p(scene.width + this.startAnimation.width / 2, 0);

    this.startAnimation.runAction(new cc.Sequence(
        new cc.DelayTime(0.1),
        cleverapps.effects.fireAction("match3.goals.fly"),
        new cc.MoveTo(0.9, scene.width / 2, this.startAnimation.y),
        new cc.DelayTime(1.0),
        new cc.MoveTo(0.5, targetPosition.x, this.startAnimation.y),
        new cc.CallFunc(() => {
            this.removeStartAnimation();

            targetPosition = this.getPosition();
            switch (cleverapps.resolution.mode) {
                case cleverapps.WideMode.VERTICAL: case cleverapps.WideMode.SQUARE:
                    this.setAlignment(this.x, scene.height + this.height + 2);
                    break;
                case cleverapps.WideMode.HORIZONTAL:
                    this.setAlignment(-this.width - 2, this.y);
                    break;
            }
            this.runAction(new cc.Sequence(
                new cc.DelayTime(cleverapps.styles.GoalsView.startAnimation.goals.delay),
                new cc.MoveTo(0.6, targetPosition).easing(cc.easeElasticOut(1.5))
            ));
        })
    ));
};